module.exports = __webpack_public_path__ + "static/media/code-with-logo.dd65b176.png";